import React from "react";
import { Link } from "react-router-dom";
import nourTuneLogo from "../../nourtunelogohome.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>© 2026 NourTune</p>

        <Link to="/">
          <img src={nourTuneLogo} alt="NourTune Logo" className="footer-logo" />
        </Link>

        <p>
          NourTune is a creative rhyme platform part of Telelumiere , where
          words meet rhythm.
        </p>

        <a href="#about">About</a>
        <a href="#features">Features</a>
        <a href="#launch">Launch</a>

        <p>
          Powered by{" "}
          <Link
            to="https://valoores.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              fontWeight: "800",
              color: "white",
            }}
          >
            Valoores
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
